<template>
  <div class="col-md-6 mb-3">
    <div 
      class="notice-card" 
      :class="{ 'notice-card-valid': isValid, 'notice-card-invalid': !isValid }"
      @click="onNoticeClick"
    >
      <div class="notice-card-header">
        <div class="notice-title-wrapper">
          <div class="notice-title">{{ props.data.title }}</div>
          <div class="notice-updated-date">
            {{ moment(props.data.updatedAt).format("YYYY-MM-DD") }}
          </div>
        </div>
      </div>
      
      <div class="notice-card-body">
        <div class="notice-content">
          {{ plainContent }}
        </div>
      </div>
    </div>
  </div>

  <NoticeItemModal
    v-if="noticeItemModal.visible"
    :visible="noticeItemModal.visible"
    :cancelCallback="noticeItemModal.hide"
    :data="props.data"
  />
</template>

<script setup>
import { defineProps, computed, getCurrentInstance, reactive } from 'vue';
import moment from 'moment';
import NoticeItemModal from './NoticeItemModal.vue';
import useModal from '@/common/hooks/useModal';

const props = defineProps(['index', 'data']);
const noticeItemModal = reactive(useModal());

const isValid = computed(() => {
  const startValue = moment(props.data.startDate).format("YYYYMMDD");
  const endValue = moment(props.data.endDate).format("YYYYMMDD");
  const todayValue = moment().format("YYYYMMDD");
  return startValue <= todayValue && endValue >= todayValue;
});

const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const plainContent = computed(() => {
  return stripHtml(props.data?.content || '');
});

const onNoticeClick = () => {
  noticeItemModal.show();
};
</script>

<style scoped>
.notice-card {
  background-color: #ffffff;
  border-radius: 1.2rem;
  padding: 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e9ecef;
}

.notice-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.notice-card-invalid {
  background-color: #f8f9fa;
  opacity: 0.7;
}

.notice-card-header {
  margin-bottom: 0.75rem;
}

.notice-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.notice-title {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  flex: 1;
  line-height: 1.4;
}

.notice-badge {
  display: inline-block;
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(13, 110, 253, 0.3);
}

.notice-card-body {
  margin-top: 0.5rem;
}

.notice-content {
  font-size: 0.875rem;
  color: #495057;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-updated-date {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 1rem;
}

@media (max-width: 768px) {
  .notice-card {
    padding: 1rem;
  }
  
  .notice-title {
    font-size: 0.95rem;
  }
  
  .notice-content {
    font-size: 0.8rem;
  }
  
  .notice-updated-date {
    font-size: 0.8rem;
  }
}
</style>